import { useTranslation } from 'react-i18next';

type Props = {
  content?: string | null;
};

export default function UserImportantAlertBanner({ content }: Props) {
  const { t } = useTranslation();

  if (!content) return null;

  return (
    <div className="mx-5 mb-4 rounded-md border border-orange-300 bg-orange-50 px-4 py-3 text-orange-950">
      <div className="mb-1 text-xs font-bold uppercase tracking-wide">
        {t('front.userImportantAlert.title')}
      </div>
      <div className="whitespace-pre-line text-sm font-semibold">{content}</div>
    </div>
  );
}
